// ABOUTME: Creates identifiers that let the server recognize retried client requests.
// ABOUTME: Uses the browser UUID API when available and a compatible local fallback.

export const generateClientRequestId = () => {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

const sortValue = (value: any): any => {
    if (Array.isArray(value)) {
        return value.map(sortValue);
    }
    if (!value || typeof value !== "object") {
        return value;
    }
    if (value instanceof File || value instanceof Blob) {
        return {
            name: value.name,
            size: value.size,
            type: value.type
        };
    }
    return Object.keys(value)
        .sort()
        .reduce((acc: Compleo.IObject, key) => {
            if (
                value[key] !== undefined &&
                key !== "clientRequestId" &&
                key !== "idempotencyKey" &&
                key !== "FileInfo" &&
                key !== "streamContent"
            ) {
                acc[key] = sortValue(value[key]);
            }
            return acc;
        }, {});
};

export const buildClientRequestFingerprint = (values: Compleo.IObject) =>
    JSON.stringify(sortValue(values));
